import angular from "angular";

angular
    .module('app')
    .component('groupStudentsControl', {
        template: require('./group-students-control.html'),
        controller: ['$http', 'Notifier', '$uibModal', 'moment', '$timeout', 'Auth', controller],
        bindings: {
            course: '<',
            group: '<'
        }
    });

function controller($http, Notifier, $uibModal, moment, $timeout, Auth) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = '20';

    $ctrl.search = null;
    $ctrl.curretLessonId = null;

    $ctrl.orderBy = 'attached_at';
    $ctrl.orderDir = 'desc';

    $ctrl.$onInit = function () {
        $ctrl.user = Auth.user();
        $ctrl.getList();
    };

    $ctrl.reset = function () {
        $ctrl.page = 1;
        $ctrl.search = null;
        $ctrl.curretLessonId = null;
        $ctrl.status = null;
        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.perPageChanged = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.export = function () {
        $http
            .post(`/admin/courses/${$ctrl.course.id}/groups/${$ctrl.group.id}/export-students`, {
                order_by: $ctrl.orderBy,
                order_dir: $ctrl.orderDir,
                search: $ctrl.search,
                status: $ctrl.status,
                current_lesson_id: $ctrl.curretLessonId
            })
            .then(function (response) {
                const fileName = response.data.name;
                window.open('/storage/' + fileName);
            });
    };

    $ctrl.setOrderBy = function (orderBy) {
        if ($ctrl.orderBy == orderBy) {
            $ctrl.orderDir = $ctrl.orderDir == 'asc' ? 'desc' : 'asc';
        } else {
            $ctrl.orderBy = orderBy;
            $ctrl.orderDir = 'asc';
        }

        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        $http
            .get(`/admin/courses/${$ctrl.course.id}/groups/${$ctrl.group.id}/get-students`, {
                params: {
                    page: $ctrl.page,
                    per_page: $ctrl.perPage,
                    order_by: $ctrl.orderBy,
                    order_dir: $ctrl.orderDir,
                    search: $ctrl.search,
                    status: $ctrl.status,
                    current_lesson_id: $ctrl.curretLessonId
                }
            })
            .then(
                function (response) {
                    $ctrl.students = response.data.data;
                    $ctrl.total = response.data.total;
                    $ctrl.students.forEach(function (student, ind) {
                        student.number = ($ctrl.page - 1) * $ctrl.perPage + ind + 1;
                        if (student.course_status == 'active') {
                            let currentLesson = student.lesson_statuses.find(v => v.status == 'current');
                            if (currentLesson) {
                                student.currentLessonInfo = findLessonById(currentLesson.lesson_id);
                            }
                        }
                    });
                },
                function (error) {

                }
            );
    };

    function findLessonById(lessonId) {
        for (let i = 0; i < $ctrl.course.chapters.length; i++) {
            for (let j = 0; j < $ctrl.course.chapters[i].lessons.length; j++) {
                if ($ctrl.course.chapters[i].lessons[j].id == lessonId) {
                    return {
                        chapterInd: i,
                        lessonInd: j,
                        title: $ctrl.course.chapters[i].lessons[j].title
                    };
                }
            }
        }
        return null;
    }

    $ctrl.openAttachModal = function () {
        $uibModal
            .open({
                component: 'groupStudentsAttachModal',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    },
                    group: function () {
                        return $ctrl.group;
                    }
                }
            })
            .result
            .then(
                function () {
                    $ctrl.orderBy = 'attached_at';
                    $ctrl.orderDir = 'desc';
                    $ctrl.reset();
                },
                function (error) {
                }
            );
    };

    $ctrl.openImportModal = function () {
        $uibModal
            .open({
                component: 'groupImportStudentsModal',
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    },
                    group: function () {
                        return $ctrl.group;
                    }
                },
                size: 'lg',
                keyboard: false,
                backdrop: 'static',
            })
            .result
            .then(
                function () {
                    $ctrl.orderBy = 'attached_at';
                    $ctrl.orderDir = 'desc';
                    $ctrl.reset();
                },
                function () {
                }
            );
    };

    $ctrl.openAttachNewStudentModal = function () {
        $uibModal
            .open({
                component: 'userCreateForm',
                size: 'md',
                keyboard: false,
                backdrop: 'static'
            })
            .result
            .then(
                function (response) {

                    let user = {
                        id: response.id,
                        full_name: response.full_name,
                        phone: response.phone,
                        pivot: {status: 'active',created_at:moment()},
                    };

                    $ctrl.attachUserToCourse(user);
                },
                function () {

                }
            );
    };

    $ctrl.attachUserToCourse = function (user){
        $http
            .post(`/admin/courses/${$ctrl.course.id}/groups/${$ctrl.group.id}/attach-student`, {user_id: user.id})
            .then(
                function (response) {
                    $ctrl.reset();
                },
                function (error) {
                    if (error.status == 422) {
                        $ctrl.validationErrors = error.data.errors;
                        Notifier.error('Ошибка при заполнении', 2);
                    } else {
                        Notifier.error('Произошла ошибка с текстом:' + error.data.message, 2);
                    }
                }
            );
    };

    $ctrl.openUserCourseControl = function (user, ind) {
        $uibModal
            .open({
                component: 'userCourseControl',
                resolve: {
                    user: function () {
                        return user;
                    },
                    course: function () {
                        return $ctrl.course;
                    },
                    group: function () {
                        return $ctrl.group;
                    }
                },
                size: 'lg',
            })
            .result
            .then(
                function (response) {
                    if (response.action == 'detach') {
                        $ctrl.students.splice(ind, 1);
                        $ctrl.total--;
                    }
                    if (response.status){
                        user.course_status = response.status;
                    }
                },
                function () {
                }
            );
    };

}
